<template>
  <div class="visitor-item">
    <div class="item">
      <div class="row flex">
        <div v-if="visitor.avatar" class="col-md-1 col-xs-1" style="padding: 0">
          <div class="visitor-avatar"
               :style="[{'background-image' : 'url(' + visitor.avatar + ')'} ]">
          </div>
        </div>
        <div :class="{ 'col-md-5 col-sm-4 col-xs-3': visitor.avatar }" class="col-md-6 col-sm-5 col-xs-4">
          <h4>
            {{ visitor.fullname_last }} {{ visitor.fullname_first }} {{ visitor.fullname_patronymic }}
            <template v-if="visitorsBlacklist[visitor.id]">
              <img
                v-tooltip="{ content: 'Данный посетитель находится в черном списке' }"
                :src="baseUrl + '/img/lock.png'" class="lock-icon" alt="lock"
              >
            </template>
            <span v-if="visitor.duplicates" class="visitor-passport-is-duplicate">
              <label style="margin-bottom: auto">!</label>
              <div class="form-fieldhelp-text">
                <div style="font-size: 14px; font-weight: normal">
                  Паспорт с&nbsp;таким же номером встречается у&nbsp;других посетителей
                </div>
              </div>
            </span>
          </h4>
        </div>
        <div class="col-md-2 col-sm-2 col-xs-3">
          <b>{{ visitor.birthday }}</b>
        </div>
        <div class="col-md-1 col-xs-2 visitor-nationality">
          <img
            v-if="visitor.nationality && visitor.nationality.iso2"
            :src="baseUrl + '/img/icons/' + visitor.nationality.iso2 + '.svg'"
            :title="visitor.nationality.fullName"
            :alt="visitor.nationality.fullName"
            class='nationality-flag'
          >
        </div>
        <div class="col-md-3 col-sm-3 col-xs-3">
          <div class="pull-right">
            <button
              v-if="!visiblePassports"
              :title="titleApplicationsButton"
              role="button"
              class="btn btn-default"
              @click="changeVisibleApplications"
            >
              <i class="fa fa-bars"></i>
              &nbsp;
              <i :class="{ 'fa-angle-down': !visibleApplications, 'fa-angle-up': visibleApplications }" class="fa"></i>
            </button>
            &nbsp;
            <button
              :title="titlePassportsButton"
              :style="{ 'border-color': passportsFailedLoad ? '#d0312d' : '#ccc' }"
              role="button"
              class="btn btn-default"
              @click="changeVisiblePassports"
            >
              <i v-if="showPassportsSpinner" class="fa fa-spinner fa-spin"></i>
              <i v-else class="fa fa-address-card-o" aria-hidden="true"></i>
              &nbsp;
              <i :class="{ 'fa-angle-down': !visiblePassports, 'fa-angle-up': visiblePassports }" class="fa"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="visiblePassports">
      <div v-for="(passport, passportKey) in passports" :key="passportKey">
        <visitor-passport-item
          :passport="passport"
          :passport-key="passportKey"
          :visitor-key="visitorKey"
          :statuses="statuses"
          :duplicates="visitor.duplicates"
          @open-application="openApplication"
          @update-statuses="updateStatuses"
          @splice-application="spliceApplication"
        />
      </div>
    </div>

    <div v-if="!visiblePassports && visibleApplications">
      <div
        v-for="(application, applicationKey) in applications"
        :key="applicationKey"
        :class="applicationCSSClass(application)"
        class="application-list"
        @dblclick="openApplication(applicationKey)"
      >
        <visitor-application-item
          :visitor-key="visitorKey"
          :application=application
          :application-key="applicationKey"
          :pagination="pagination"
          :user="user"
          :statuses="statuses"
          @update-statuses="updateStatuses"
          @splice-application="spliceApplication"
        />
      </div>

      <infinite-loading :identifier="infiniteId" @infinite="infiniteLoadApplications">
        <div slot="no-more">Показаны все записи</div>
        <div slot="no-results">Нет записей</div>
      </infinite-loading>
    </div>

    <hr v-if="visiblePassports || visibleApplications">
  </div>
</template>

<script>
import '@/common/assets/styles/application.scss'
import VisitorClient from '../../helpers/api-client/Visitor'
import VisitorApplicationItem from './VisitorApplicationItem.vue'
import VisitorPassportItem from './VisitorPassportItem.vue'
import ApplicationLogListDto from '../../classes/dto/ApplicationLogListDto'
import PassportApplicationList from './PassportApplicationList.vue'

export default {
  name: 'VisitorItem',

  components: { VisitorPassportItem, VisitorApplicationItem },

  props: {
    applicationMenuConfiguration: {
      type: [Object, Array]
    },
    statuses: { type: Object },
    visitor: {
      avatar: String,
      fullname_last: String,
      fullname_first: String,
      fullname_patronymic: String,
      birthday: String,
      nationality: {
        iso2: String,
        fullName: String
      },
      duplicates: Array
    },
    visitorsBlacklist: {
      type: [Object, Array],
      default: () => {}
    },
    visitorKey: Number
  },

  data() {
    return {
      applications: [],
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      infiniteId: 0,
      pagination: {
        active: 1,
        per: 5
      },
      passports: [],
      showApplications: false,
      showPassports: false,
      showPassportsSpinner: false,
      titleApplicationsButton: 'Показать список заявок',
      titlePassportsButton: 'Показать информацию о пользователе'
    }
  },

  computed: {
    visibleApplications() {
      return this.showApplications
    },

    visiblePassports() {
      return this.showPassports && this.passports
    },

    passportsFailedLoad() {
      return this.passports === null
    }
  },

  methods: {
    applicationCSSClass(application) {
      return 'profile-application-color-' + application.status
    },

    async changeVisibleApplications() {
      this.titleApplicationsButton = 'Показать список заявок'
      if (!this.showApplications) {
        this.titleApplicationsButton = 'Скрыть список заявок'
      }
      this.showApplications = !this.showApplications
    },

    async changeVisiblePassports() {
      this.titlePassportsButton = 'Показать информацию о пользователе'
      if (!this.showPassports) {
        this.titlePassportsButton = 'Скрыть информацию о пользователе'
        if (this.passports === null || this.passports?.length === 0) {
          this.showPassportsSpinner = true
          await this.getPassports()
            .catch(() => {
              this.showPassportsSpinner = false
            })
        }
      }
      this.showPassportsSpinner = false
      if (this.passports === null || this.passports?.length === 0) {
        return
      }
      this.showPassports = !this.showPassports
    },

    async infiniteLoadApplications($state) {
      if (!this.applications.length) {
        this.pagination.active = 1
      }

      const applications = await this.getApplications()

      if (applications?.length) {
        this.pagination.active++
        this.applications.push(...applications)
        $state.loaded()
      } else if (applications?.length === 0) {
        $state.complete()
      } else {
        $state.error()
      }
    },

    async getApplication(applicationId) {
      let application

      await VisitorClient.getApplication({
        visitorId: this.visitor.id,
        applicationId: applicationId
      }).then((response) => {
        application = response?.data?.data
      })

      return application
    },

    async getApplications() {
      let results = []

      await VisitorClient.getApplications({
        page: this.pagination.active,
        perPage: this.pagination.per,
        visitorId: this.visitor.id
      }).then((response) => {
        if (response?.data?.data?.length > 0) {
          results = response?.data?.data?.map(
            model => Object.assign(model, {
              logs: new ApplicationLogListDto(model.logs)
            })
          )
        }
      })

      return results
    },

    async getPassports() {
      await VisitorClient.getPassports({
        visitorId: this.visitor.id
      }).then((response) => {
        this.passports = response?.data?.data
      })
    },

    openApplication(applicationKey) {
      const applicationMenu = document.getElementById(`visitor-dropdown-${this.visitorKey}-${applicationKey}`)
      document.location.href = applicationMenu.querySelector('li.watch-button > a').getAttribute('href')
    },

    async spliceApplication(deleteFrom, blockId, applicationId, index) {
      const application = await this.getApplication(applicationId)
      if (application) {
        this.applications.splice(index, 1, application)
      }
    },

    updateStatuses(status) {
      const allowedStatuses = this.statuses.allowed_statuses

      if (!allowedStatuses.find(x => x.id === status)) {
        const findStatus = this.statuses.all_statuses.find(x => x.id === status)
        allowedStatuses.push(findStatus)
        allowedStatuses.sort((a, b) => a.name.localeCompare(b.name))
      }
    }
  }
}
</script>
